import type { PrintMethod, ProductModel } from '@ox/schema';

/** Shared print-service options for quote / cart payloads. */
export function printServiceQuoteFields(selection: {
  garmentPrintType?: 'no_white_base' | 'white_base';
  franelaReactiva?: boolean;
  colorKey?: string;
  colorHex?: string;
}): {
  garmentPrintType?: 'no_white_base' | 'white_base';
  needsWhiteBase?: boolean;
  franelaReactiva?: boolean;
  garmentColor?: string;
} {
  const type = selection.garmentPrintType;
  const hexRaw = (selection.colorHex || selection.colorKey || '').trim().replace(/^#/, '');
  const garmentColor = /^[0-9a-fA-F]{6}$/i.test(hexRaw) ? hexRaw.toLowerCase() : undefined;
  if (!type && !selection.franelaReactiva && !garmentColor) {
    return {};
  }
  return {
    ...(type ? { garmentPrintType: type, needsWhiteBase: type === 'white_base' } : {}),
    ...(selection.franelaReactiva
      ? { franelaReactiva: true }
      : type || garmentColor
        ? { franelaReactiva: false }
        : {}),
    ...(garmentColor ? { garmentColor } : {}),
  };
}

/** Active model id + print method for multi-model products. */
export function modelQuoteFields(model: ProductModel | null | undefined): {
  modelId?: string;
  printMethod?: PrintMethod;
} {
  if (!model?.id) return {};
  return {
    modelId: model.id,
    printMethod: (model.printMethod || 'dtg') as PrintMethod,
  };
}
